import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import authAction from '../../redux/auth/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import CONFIG from '../../settings';
import { AppState } from '../../redux/redux.model';
import { UnstyledButton } from '../../components/button/unstyledButton';

const { logoutRequest } = authAction;

const anonymousUserImage = `https://${CONFIG.baseS3BucketName}/user-anonymous.png`;

const TopbarUser = () => {
  const currentUser = useSelector((state: AppState) => state.User.currentUser);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  const handleLogout = () => {
    dispatch(logoutRequest());
  };

  const content = (
    <TopbarDropdownWrapper className='isoUserDropdown'>
      <UnstyledButton className='isoDropdownLink' onClick={() => handleLogout()}>
        <IntlMessages id='topbar.logout' />
      </UnstyledButton>
    </TopbarDropdownWrapper>
  );
  return (
    <Popover
      content={content}
      trigger='click'
      visible={visible}
      onVisibleChange={() => setVisible(!visible)}
      arrowPointAtCenter
      placement='bottomLeft'>
      <div className='isoImgWrapper'>
        {currentUser?.id ? (
          <img
            alt='user'
            style={{ borderRadius: '50%' }}
            src={`https://${CONFIG.baseS3BucketName}/user-${currentUser.id}`}
            onError={e => {
              const img = e.target as HTMLImageElement;
              img.onerror = null;
              img.src = anonymousUserImage;
            }}
          />
        ) : (
          <img alt='user' data-testid='anonymous-user-image' style={{ borderRadius: '50%' }} src={anonymousUserImage} />
        )}
      </div>
    </Popover>
  );
};

export default TopbarUser;
